import {
  Component,
  OnInit,
  Input,
  ViewChild,
  SimpleChanges
} from "@angular/core";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { CommonService } from "../services/common.service";
import {  Subject } from "rxjs";
import { ToastrService } from "ngx-toastr";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import beautify from "xml-beautifier";
declare var $

declare const copyToClipboard: any;

@Component({
  selector: 'app-rule-engine-try-it-out',
  templateUrl: './rule-engine-try-it-out.component.html',
  styleUrls: ['./rule-engine-try-it-out.component.scss']
})
export class RuleEngineTryItOutComponent implements OnInit {
    selectedrouteIdgblGqr: string = ''; 
  
      inputdata: any;
      pdfviwerflag: boolean=false;
      OutputData: string = "";
      formatType: string = "text/plain";
      defaultFormatType:string='text/plain';
      defaultFormatTypeGqr:string='text/plain';
      previewDataXMl: boolean = false;
      public reactiveFormdeployment: FormGroup;
      deploymentItemsList = [];
      deploymentSelected: string = '';
  
      editorOptions = {
          theme: 'vs', language: this.defaultFormatType, wordWrap: 'on',scrollBeyondLastLine: false
      };
  
      editorOptions1 = {theme: 'vs', language: this.defaultFormatType,readOnly:true, wordWrap: 'on',scrollBeyondLastLine: false
      };

      editorOptionsGqr = {
        theme: 'vs', language: this.defaultFormatTypeGqr, wordWrap: 'on',scrollBeyondLastLine: false,automaticLayout: true 

    };

    editorOptionsGqr1 = {theme: 'vs', language: this.defaultFormatTypeGqr,readOnly:true, wordWrap: 'on',scrollBeyondLastLine: false
    };
      reactiveFormroutegbl: FormGroup;
      reactiveFormroutegblGqr: FormGroup;
      onvaluechange: Subject<string> = new Subject<string>();
      inputdatabackupdata: string;
      fileName: string;
    selectedrouteDisplayNamegblGqr: any;
    isLoadingroutesGqr: boolean = false;
routedetailsGqr: any;
notfounddataGqr: any;
reactiveFormagent: FormGroup;
isLoadingagent: boolean = false;
 AgentNameList: any[];
 selectedAgentguid: any;
    selectedAgentName: any;
    AgentDetailsList: any[];
    agenttype: string;
    agentstatusvalue: string;
    agentmodevalue: string;
    selectedrouteuniqueid: any;
    agentmodelist: any;
    agentstagelist: any;
    public reactiveFormmsgtype: FormGroup;
    isLoadingmessagetype: boolean = false;
    
    messageTypeList: any = [];
    messageTypeAllList: any = [];
    qualifiedRoutesList: { id: string; displayname: string }[] = []; 
  
      constructor(private _formBuilder: FormBuilder,private ngxUiLoaderService: NgxUiLoaderService, public service: CommonService, private _fb: FormBuilder, public activeModal: NgbActiveModal, private modalService: NgbModal, private toastr: ToastrService, private commonService: CommonService) {
          
          this.reactiveFormroutegbl = _fb.group({ routenamegbl: '' });
          this.reactiveFormroutegblGqr = _fb.group({ routenamegblGqr: '' });
          this.reactiveFormagent = _fb.group({ agentname: '' });
          this.reactiveFormmsgtype = this._fb.group({ msgname: '' });
          //this.deploymentSelected=this.deploymentItemsList.find(V=>V.toLowerCase()==obj.dkey.toLowerCase());
          
          this.reactiveFormdeployment = this._formBuilder.group({ deploymentname: ['', Validators.required] });
      }
      screeHeightforoutput: number;
      screeHeightforinput: number;
      screeHeightforinputGqr: number;
      enableAccessionSearch: boolean = false;
      fileUploadFTP: boolean;
      routedetails: {
          RouteIdtry: any;
          ProcessorIdtry: any;
          ProcessorDisplayNametry: any;
          RouteDisplayNametry: any;
          Processorapikey: any;
          Popupflag: boolean;
          MappedXmlTemp: string;
          isFileUpload: boolean;
          isfiledownload: boolean;
          interfacetype: any;
          enableAccessionSearch: boolean;
          fileUploadFTP: boolean;
          sourcedeploymentkey: any;
          targetdeploymentkey: any;
          sourceaccounttype: any;
          targetaccounttype: any;
          seguid: any;
          deguid: any;
          sourceagent: any
      };
      versionDetails: any[];
      versionList: string[] = [];
      version: any;
      notfounddata: boolean;
     
      backupfileArray: any[]=[];
      routeMessageType:any;
      uniqueid: any;
      isValidationFlag:boolean;
      routeUniqueID: any;
      connectivitytype:string='';
      fileContent: string;
      inputdataGqr: any;
      editorInit(editor) {
          if(editor!==undefined && editor!==''){
                  if (this.inputdata) {
                      if (this.inputdata.byteLength > 0) {
                          if (this.OutputData.trim().startsWith("<")) {
                              this.formatType = "xml";
                          } else if (this.OutputData.trim().startsWith("{")) {
                              this.formatType = "json";
                          }
                      }
                      else if (this.inputdata.trim().startsWith("<") || this.OutputData.trim().startsWith("<")) {
                          this.formatType = "xml";
                      } else if (this.inputdata.trim().startsWith("{") || this.OutputData.trim().startsWith("{")) {
                          this.formatType = "json";
                      }
                  }
              if(this.defaultFormatType!=this.formatType){
                  this.defaultFormatType=this.formatType;
                  this.editorOptions = {
                      ...this.editorOptions,
                      language: this.formatType
                  };
                  this.editorOptions1 = {
                      ...this.editorOptions1,
                      language: this.formatType,
                      readOnly:true
                  };
              }
              }
      }
  
      editorInitGqr(editor) {
        if(editor!==undefined && editor!==''){
                if (this.inputdataGqr) {
                    if (this.inputdataGqr.byteLength > 0) {
                        if (this.OutputData.trim().startsWith("<")) {
                            this.formatType = "xml";
                        } else if (this.OutputData.trim().startsWith("{")) {
                            this.formatType = "json";
                        }
                    }
                    else if (this.inputdataGqr.trim().startsWith("<") || this.OutputData.trim().startsWith("<")) {
                        this.formatType = "xml";
                    } else if (this.inputdataGqr.trim().startsWith("{") || this.OutputData.trim().startsWith("{")) {
                        this.formatType = "json";
                    }
                }
            if(this.defaultFormatTypeGqr!=this.formatType){
                this.defaultFormatTypeGqr=this.formatType;
                this.editorOptionsGqr = {
                    ...this.editorOptionsGqr,
                    language: this.formatType
                };
                this.editorOptionsGqr1 = {
                    ...this.editorOptionsGqr1,
                    language: this.formatType,
                    readOnly:true
                };
            }
            }
    }

    onTabChange(event: any): void {
        if (event.index === 1) { 
          setTimeout(() => {
            this.screeHeightforinputGqr = window.innerHeight - 281; 
          }, 100);
        }
      }
      registerMonacoCustomTheme() {
          monaco.editor.defineTheme("myCustomTheme", {
              base: "vs", 
              inherit: true, 
              rules: [
                  {
                      token: "comment",
                      foreground: "ffa500",
                      fontStyle: "italic underline"
                  }, {
                      token: "comment.js",
                      foreground: "008800",
                      fontStyle: "bold"
                  }, {
                      token: "comment.css",
                      foreground: "0000ff"
                  }, 
              ],
              colors: {}
          });
      }
  
      RouteIdtry: string;
      ProcessorIdtry: string;
      classObjalert: string;
      StatusMessage: string;
     
      statusmessagetryitout: boolean = false;
      Processorapikey: string;
      IsFileUpload: boolean = false;
      IsFileDownload: boolean = false;
      popupflag: boolean = true;
      MappedXmlTemp: string;
      filecheck: boolean;
      
      fileidValue: string;
      sourceaccounttype: string = "";
      targetaccounttype: string = "";
      seguid: string = "";
      deguid: string = "";
      ngoniniteditorcall:any;
      flag=false;
      ngOnInit() {
        this.getDeployments();
        this.reactiveFormdeployment.patchValue({ "deploymentname": this.deploymentSelected });
        this.getMessagetypelist('msgtype');
          this.screeHeightforoutput = window.innerHeight - 210;
          this.screeHeightforinput = window.innerHeight - 281;
          this.screeHeightforinputGqr= window.innerHeight - 281;
    
              this.fileUploadFTP = false;
              this.enableAccessionSearch = false;
           
              this.popupflag = false;
              this.MappedXmlTemp = "";
            
          this.flag=true;
      }
      isValuefromInput: boolean = false;

      getstringRoute(value) {
          let names = value.split("(")
          value = `${names[0]} <br>(${names[1]} <br>(${names[2]}`
          return value
      }
      searchkey: string = "";
      GetxmlByAccessionNumber() {
          this.inputdata = "";
          this.OutputData = "";
          if (this.searchkey) {
  
              let isvalid = false;
              if (this.searchkey.indexOf(',') > -1) {
                  //isvalid = true;
                  this.toastr.warning("Multiple Accession Search is not supported!", "", {
                  timeOut: 4000,
                  positionClass: 'toast-bottom-right'
              });
              
              }
              else if (this.searchkey.split(',').length <= 5) {
                  isvalid = true;
              }
              if (isvalid) {
                  let dpkey = "";
                  if ( (this.routedetails != undefined && (this.routedetails.interfacetype === "Outbound" || this.routedetails.interfacetype === "EllkayResultOutbound"))) 
                      dpkey =  this.routedetails.sourcedeploymentkey ;
               
  
                  this.ngxUiLoaderService.start();
                  var apiname = "api/CoreConfig/GetProcessorUIConfig?agentid=&apikey=";
                  this.service.getapi(apiname).then(responseconfig => {
                      ;
                      var configs = JSON.parse(responseconfig.responsebody);
                      var dpconfig = configs[dpkey];
                     
                      var searchData = {
                          "id":  this.routedetails.ProcessorIdtry ,
                          "type": "Processor"
                      };
                      var messagetype = "";
                      var apiname = 'api/Agents/GetSearchDetails';
                      this.service.searchpostapi(apiname, searchData).then(responseagent => {
                          const resultset = responseagent as any[];
                          var processoragentconfigdata;
                          if (resultset[0]["jsonconfig"]) {
                              var jsonconfig = JSON.parse(resultset[0]["jsonconfig"]);
                              processoragentconfigdata = jsonconfig.processoragentconfig;
                              if (processoragentconfigdata != undefined) {
                                  if (processoragentconfigdata.messagetype) {
                                      messagetype = processoragentconfigdata.messagetype;
                                  }
                              }
                          }
                          if (messagetype.toLowerCase() == 'result') {
                              messagetype = "Results";
                          } else if (messagetype.toLowerCase() == 'order') {
                              messagetype = "Orders";
                          }
                          var EntityType = '';
                          var EntityValue = '';
                          let isEmptyAccounttype = false;
                          if (this.routedetails && this.routedetails.targetaccounttype == "") {
                              this.ngxUiLoaderService.stop();
                              this.toastr.error("Account type of the Destination entity is not available", "", {
                                  timeOut: 4000,
                                  positionClass: 'toast-bottom-right'
                              });
                              isEmptyAccounttype = true;
                          }
                          if (!isEmptyAccounttype) {
                            this.ngxUiLoaderService.start();
                              if ( this.routedetails != undefined && (this.routedetails.interfacetype === "Outbound" || this.routedetails.interfacetype === "EllkayResultOutbound")) {
                                  EntityType = this.routedetails.sourceaccounttype ;
                                  EntityValue =  this.routedetails.seguid ;
                              } 
                              
                              var inputsearch = {
                                  "AccessionnumberList": this.searchkey.split(','),
                                  "EntityType": EntityType,
                                  "EntityValue": EntityValue,
                                  "MessageType": messagetype,
                                  "Headers": JSON.stringify(dpconfig.apidetails["headers"]),
                                  "Url": dpconfig.apidetails["inputxmlapiurl"]
                              }
                              this.getcasexml(inputsearch);
  
                          }
                      });
                  });
  
              }
             
          }
          else {
              this.toastr.warning("Please enter the accession number!!", "", {
                  timeOut: 4000,
                  positionClass: 'toast-bottom-right'
              });
          }
  
      }
      inputxml = [];
      getcasexml(input) {
          this.inputxml = [];
          let counter = 0;
          for (let i = 0; i < input.AccessionnumberList.length; i++) {
  
              let obj = {
                  "Accessionnumber": input.AccessionnumberList[i],
                  "EntityType": input.EntityType,
                  "EntityValue": input.EntityValue,
                  "MessageType": input.MessageType,
                  "Headers": input.Headers,
                  "Url": input.Url
              }
              this.service.postapi("api/TransformXml/GetInputXML", obj).then(dxresponse => {
  
                  if (!dxresponse || !dxresponse['responsemessage']) {
                      this.ngxUiLoaderService.stop();
                      this.toastr.warning("No data found", "", {
                          timeOut: 4000,
                          positionClass: 'toast-bottom-right'
                          });
                      
                  }
                  else if (!dxresponse['xml'] && dxresponse['responsemessage']) {
                      this.ngxUiLoaderService.stop();
                      this.inputdata = dxresponse['responsemessage'];
                  }
                  else if (dxresponse['responsemessage'] && dxresponse['xml']) {
  
                          this.inputdata = dxresponse["xml"];
                          //this.searchkey = "";
                          this.ngxUiLoaderService.stop();
                      
                  } else {
                      this.ngxUiLoaderService.stop();
                      this.toastr.warning("Not data found", "", {
                              timeOut: 4000,
                              positionClass: 'toast-bottom-right'
                          });
                      this.searchkey = "";
                  }                
              });
  
          }
  
      }
     
  
     
      clearAll() {
          this.classObjalert = "col-sm-5";
          this.OutputData = "";
          this.StatusMessage = "";
          
          this.previewDataXMl = false;
          this.fileidValue = "";
          
          this.filecheck = false;
          this.notfounddata = false;
          this.notfounddataGqr = false;
       
          this.searchkey='';
          this.deploymentSelected = '';
    this.reactiveFormdeployment.reset();
    this.reactiveFormdeployment.patchValue({ "deploymentname": '' });
    this.reactiveFormdeployment.patchValue(this.deploymentItemsList);
      }

       // Clear all for ValidateRule
  clearAllValidateRule(): void {
    this.inputdata = ''; 
    this.reactiveFormroutegbl.reset(); 
    this.selectedrouteIdgbl = ''; 
    this.selectedrouteDisplayNamegbl = ''; 
    this.validationStatusMessage = ''; 
    this.clearAll();
    this.searchRouteNameClearedgbl(null);
  }

  // Clear all for GetQualifiedRoutes
  clearAllGetQualifiedRoutes(): void {
    this.inputdataGqr = ''; 
    this.reactiveFormagent.reset(); 
    this.reactiveFormmsgtype.reset(); 
    this.selectedAgentguid = ''; 
    this.selectedmessagetype = ''; 
    this.qualifiedRoutesList = []; 
    this.clearAll();
    this.Clearemessagetype(null);
  }
  
      copyToClip(event: any, message: any) {
          if (event != "") {
              var xmlDocument;
              try {
                  xmlDocument = (new DOMParser()).parseFromString(event, 'text/xml');
              }
              catch {
                  xmlDocument = "";
              }
              if (xmlDocument) {
                  event = beautify(event);
              }
              copyToClipboard(event);
             
              this.toastr.success(message + " Copied", "", {
                  timeOut: 4000,
                  positionClass: 'toast-bottom-right'
              });
          }
      }
  
      isLoadingroutes: boolean = false;
      RouteNameListgbl: any = [];
      //RouteNameListgblGqr: any[] = [];
      selectedrouteIdgbl: string = '';
      selectedrouteDisplayNamegbl: string = '';
      keywordsearchgbl: string = 'displayname';
      keywordsearchgblGqr: string = '';
      keywordsearch = "displayname";
  
      getRouteNamegbl(event: any) {
          var val = event;
          if (val) {
              this.isLoadingroutes = true;
              var apiname = "api/Routes/GetByDisplayName?name=" + val + "&version=0";
              this.service.getapiurl(apiname).subscribe({
                  next: data => {
                      this.RouteNameListgbl = data as any[];
                      this.RouteNameListgbl.map(
                          obj => obj.displayname = `${obj.displayname
                              } ${'(' + obj.id + ')(VA-'+obj.UniqueID+')'
                              }`
                      );
                      //console.log('RouteNameListgbl:', this.RouteNameListgbl);
                      this.isLoadingroutes = false;
                      if (data.length == 0) {
                          this.notfounddata = true;
                      }
                      else {
                          this.notfounddata = false;
                      }
                  },
                  error: error => {
                      this.isLoadingroutes = false;
                      this.notfounddata = true;
                  }
              });
          }
  
      }
  
   
  
      selectedRoutegbl(item) {
          this.selectedrouteIdgbl = item.id;
          this.selectedrouteDisplayNamegbl = item.displayname;
          this.getRouteDetails();
      }

     

      searchRouteNameClearedgbl(event) {
          this.isLoadingroutes = false;
          this.RouteNameListgbl = [];
          this.selectedrouteIdgbl = '';
          this.selectedrouteDisplayNamegbl = '';
          this.fileUploadFTP = false;
          this.enableAccessionSearch = false;
          this.notfounddataGqr = false;
          this.filecheck = false;
          this.fileidValue = "";
          //this.notfounddata = false;
          this.routedetails = {
              RouteIdtry: "",
              ProcessorIdtry: "",
              ProcessorDisplayNametry: "",
              RouteDisplayNametry: "",
              Processorapikey: "",
              Popupflag: false,
              MappedXmlTemp: "",
              isFileUpload: false,
              isfiledownload: false,
              interfacetype: "",
              enableAccessionSearch: false,
              fileUploadFTP: false,
              sourcedeploymentkey: "",
              targetdeploymentkey: "",
              sourceaccounttype: "",
              targetaccounttype: "",
              seguid: "",
              deguid: "",
              sourceagent: ""
          }
      }

   
  
  
      async getRouteDetails() {
          this.inputdata = "";
          this.searchkey = "";
          this.OutputData = "";
          if (this.selectedrouteIdgbl != "") {
              var url = "api/Routes/GetRouteList?id=" + this.selectedrouteIdgbl;
              this.ngxUiLoaderService.start();
              this.service.getapiurl(url).subscribe({
                  next: async (data) => {
                      this.routeMessageType=data["messagetype"];
                      this.routeUniqueID=data["UniqueID"];
                      this.connectivitytype = data['Connectivity'];
                      let response = await this.getFileConfig(data["id"], data["PAID"]);
                      if (response.length>0 && response[0]["json"] != '' && response[0]["json"] != null) {
                          var jsonData;
                          var vaconfigdata;
                          var interfacetype = "";
                          if (response[0]["json"] != '' && response[0]["json"] != null) {
                              jsonData = JSON.parse(response[0]["json"]);
  
                              if (jsonData.processorconfig != undefined && jsonData.processorconfig["vaconfig"] != undefined) {
                                  vaconfigdata = jsonData.processorconfig["vaconfig"];
                              }
                              if (jsonData.processorconfig != undefined && jsonData.processorconfig["interfacetype"] != undefined) {
                                  interfacetype = jsonData.processorconfig["interfacetype"];
                              }
                          }
                          this.isValuefromInput = false;
                          if (data["INTERFACETYPE"] === "Inbound" || data["INTERFACETYPE"] === "EllkayInbound") {
                              this.fileUploadFTP = true;
                              this.enableAccessionSearch = false;
                          } else if (data["INTERFACETYPE"] === "Outbound" || data["INTERFACETYPE"] === "EllkayOutbound") {
                              this.fileUploadFTP = false;
                              this.enableAccessionSearch = true;
                          }
                          else {
                              this.fileUploadFTP = false;
                              this.enableAccessionSearch = false;
                          }
                          if (this.enableAccessionSearch || this.fileUploadFTP) {
                              this.screeHeightforinput = window.innerHeight - 288;
                          }
  
                          let isfileupload = 0;
                          let isfiledownload = 0;
                          if (vaconfigdata != undefined) {
                              isfileupload = vaconfigdata.isfileupload;
                          }
  
                          if (vaconfigdata != undefined) {
                              isfiledownload = vaconfigdata.isfiledownload;
                          }
  
                          this.routedetails = {
                              RouteIdtry: data["id"],
                              ProcessorIdtry: data["PAID"],
                              ProcessorDisplayNametry: data["PANAME"],
                              RouteDisplayNametry: data["displayname"],
                              Processorapikey: data["PAAPIKEY"],
                              Popupflag: true,
                              MappedXmlTemp: "",
                              isFileUpload: isfileupload == 0 ? false : true,
                              isfiledownload: isfiledownload == 0 ? false : true,
                              interfacetype: interfacetype,
                              enableAccessionSearch: this.enableAccessionSearch,
                              fileUploadFTP: this.fileUploadFTP,
                              sourcedeploymentkey: data["SEDEPLOYMENTKEY"],
                              targetdeploymentkey: data["DEDEPLOYMENTKEY"],
                              sourceaccounttype: data["sourcetype"],
                              targetaccounttype: data["targettype"],
                              seguid: data["SEGUID"],
                              deguid: data["DEGUID"],
                              sourceagent: data["sourceagentid"]
                          };
                          this.ngxUiLoaderService.stop();
                          
                      }
                      else {
  
                          this.ngxUiLoaderService.stop();
                          this.toastr.warning("Please check the Pipeline configurations", "", {
                              timeOut: 4000,
                              positionClass: 'toast-bottom-right'
                          });
                          
                      }
  
                  },
                  error: error => {
                      this.ngxUiLoaderService.stop();
                  }
              });
          }
      }
      async getFileConfig(routeid: string, ProcessorId: string) {
          var dataPost = {
              agentid: ProcessorId,
              guids: routeid
          };
  
          return await this.service.postapi("api/CoreConfig/GetCoreConfig", dataPost);
  
          //
      }

      isValidXML(xml: string): boolean {
        try {
          const parser = new DOMParser();
          const parsedXml = parser.parseFromString(xml, "text/xml");
          const parserError = parsedXml.getElementsByTagName("parsererror");
          return parserError.length === 0; // If no parser errors, it's valid XML
        } catch (error) {
          return false; 
        }
      }
      
      overallCheck: boolean = false;
      ruleValidationResponse: any;
      validationStatusMessage: string = '';

      validateRule() {
        if (!this.inputdata) {
          this.toastr.warning("Input data is required", "", {
            timeOut: 4000,
            positionClass: 'toast-bottom-right'
          });
          return;
        }

        if (!this.routedetails?.RouteIdtry) {
          this.toastr.warning("Pipeline is required", "", {
            timeOut: 4000,
            positionClass: 'toast-bottom-right'
          });
          return;
        }

         // Validate if inputdataGqr is valid XML
    if (!this.isValidXML(this.inputdata)) {
        this.toastr.error("Input should be in XML format", "", {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });
        return;
      }
        const requestBody = {
          xml: this.inputdata,
          routeid: this.routedetails.RouteIdtry
        };

        this.ngxUiLoaderService.start();
        this.commonService.validateRule(requestBody).subscribe(
          (response: any) => {
            this.ngxUiLoaderService.stop();
            if (response) {
              try {
                const responsebody = JSON.parse(response.responsebody);
                this.overallCheck = responsebody.OverAllCheck;
                this.ruleValidationResponse = responsebody;
                if(response.status==="Eventype Configured")
                    {
                        this.toastr.error("Eventype Configured", "Rule validation failed", {
                            timeOut: 4000,
                            positionClass: 'toast-bottom-right'
                        });
                        this.validationStatusMessage = 'Rule validation failed as eventype is configured in rule';
                    }
                else{
                if (this.overallCheck) {
                  this.toastr.success("Rule validation successful", "", {
                    timeOut: 4000,
                    positionClass: 'toast-bottom-right'
                  });
                  this.validationStatusMessage = JSON.parse(response.responsebody);
                } else {
                  this.validationStatusMessage = JSON.parse(response.responsebody);
                  this.toastr.error("Rule validation failed", "", {
                    timeOut: 4000,
                    positionClass: 'toast-bottom-right'
                  });
                }
            }
              } catch (error) {
                this.toastr.error("Error parsing validation response", "", {
                  timeOut: 4000,
                  positionClass: 'toast-bottom-right'
                });
              }
            }
          },
          (error) => {
            this.ngxUiLoaderService.stop();
            this.toastr.error("Error validating rules", "", {
              timeOut: 4000,
              positionClass: 'toast-bottom-right'
            });
          }
        );
      }

      
      

      selectedmessagetype: string = '';
  selectedmessagetypeevent(item) {
    this.selectedmessagetype = item.displayname;
  }
  
 getMessagetypelist(event) {
    const val = event;
    if(val)
    {
    this.isLoadingmessagetype = true;
      this.service.getapiurl("api/Lookup/GetMessageType?lookuptype=messagetype").subscribe({
        next: data => {
          data.forEach(element => {
            this.messageTypeAllList.push({ displayname: element });
          });
          this.messageTypeList = this.messageTypeAllList;

          this.isLoadingmessagetype = false;
          if (data.length == 0) {
            this.notfounddata = true;
          } else {
            this.notfounddata = false;
          }
        },
        error: error => {
          this.isLoadingmessagetype = false;
          this.notfounddata = true;
        }
      });
    }
  }
  
  Clearemessagetype(event) {
    this.selectedmessagetype = '';
    // this.messageTypeList = this.messageTypeAllList;
    this.messageTypeList = [];
    this.messageTypeList = this.messageTypeAllList;
  }

  getQualifiedRoutes() {
    this.qualifiedRoutesList= [];
    // Validate required inputs
    if (!this.deploymentSelected || !this.selectedmessagetype ||!this.inputdataGqr) {
      this.toastr.warning("Please fill all mandatory fields", "", {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
      return;
    }

    if (!this.deploymentSelected) {
      this.toastr.warning("Deploymentkey is required", "", {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
      return;
    }

    if (!this.selectedAgentguid) {
        this.toastr.warning("Unable to get sourceagent", "", {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });
        return;
      }

    if (!this.selectedmessagetype) {
      this.toastr.warning("Message Type is required", "", {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
      return;
    }

    if (!this.inputdataGqr) {
      this.toastr.warning("Input XML is required", "", {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
      return;
    }

   

    // Validate if inputdataGqr is valid XML
    if (!this.isValidXML(this.inputdataGqr)) {
      this.toastr.error("Input should be in XML format", "", {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
      return;
    }

    // Prepare the request body
    const requestBody = {
      xml: this.inputdataGqr,
      sourceagent: this.selectedAgentguid,
      messagetype: this.selectedmessagetype
    };

    // Start the loader
    this.ngxUiLoaderService.start();

    // Call the service method
    this.service.GetQualifiedRoutesForXML(requestBody).subscribe({
      next: (response: any) => {
        this.ngxUiLoaderService.stop();

        if (response && response.responsebody != null && response.responsebody != '[]') {
          try {
            const qualifiedRoutes = JSON.parse(response.responsebody);
            this.qualifiedRoutesList = qualifiedRoutes.map((route: any) => ({
              id: route.id,
              displayname: route.displayname
            }));

            this.toastr.success("Qualified routes fetched successfully", "", {
              timeOut: 4000,
              positionClass: 'toast-bottom-right'
            });
          } catch (error) {
            this.toastr.error("Error parsing response body", "", {
              timeOut: 4000,
              positionClass: 'toast-bottom-right'
            });
          }
        } else {
          this.toastr.error("Failed to fetch qualified routes", "", {
            timeOut: 4000,
            positionClass: 'toast-bottom-right'
          });
        }
      },
      error: (error) => {
        this.ngxUiLoaderService.stop();
        this.toastr.error("Error fetching qualified routes", "", {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });
      }
    });
  }
  //Deployment selection
  selectdeploymentEvent(item: any) {
    this.deploymentSelected = item;
    this.getAgentByDeploymentAndDirection();
  }
   onFocuseddeployment(event) {
    this.reactiveFormdeployment.patchValue(this.deploymentItemsList);
  }

  cleareddeployment(event) {
    this.deploymentSelected = '';
    this.reactiveFormdeployment.reset();
    this.reactiveFormdeployment.patchValue({ "deploymentname": '' });
    this.reactiveFormdeployment.patchValue(this.deploymentItemsList);
  }

  getDeployments() {
    this.service.getDeployments("Deployments").subscribe(
      (data) => {
        if (data.length > 0) {
          this.deploymentItemsList = data;
        } else if (data.length === 0) {
          this.deploymentItemsList = [];
        }
      },
      (error) => {
        this.toastr.error("Something went wrong", "", {
          timeOut: 4000,
          positionClass: "toast-bottom-right",
        });
      }
    );
  }

  getAgentByDeploymentAndDirection(): void {
    if (!this.deploymentSelected) {
      return; 
    }

    const direction = 'Outbound'; 

    
    this.service.GetAgentByDirectionAndDeployment(direction,this.deploymentSelected, ).subscribe({
      next: (response: any[]) => {
        if (response && Array.isArray(response) && response.length > 0) {
          
          this.selectedAgentguid = response[0].id;
        } else {
          this.selectedAgentguid = '';
        }
      },
      error: () => {
       
        this.selectedAgentguid = '';
      }
    });
  }
}